import { z } from 'zod';

export const MoneyStr = z
  .string()
  .regex(/^-?\d+(\.\d{1,4})?$/, 'must be a decimal string with up to 4 fraction digits');

export const PositiveMoney = MoneyStr.refine((v) => !v.startsWith('-') && v !== '0', {
  message: 'must be > 0',
});

// Код валюты: 2-12 заглавных букв/цифр. Раньше был z.enum по статичному списку;
// теперь валюты добавляются через UI — формат проверяет схема, существование
// проверяет БД (reference.currencies) в местах, где это критично (createOrder,
// usdt-rates endpoints).
export const CcyCodeSchema = z.string().regex(/^[A-Z0-9]{2,12}$/, 'invalid currency code');

export const IsoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD');

export const ProvodkaStatusSchema = z.enum(['pending', 'done']);
export const StatusFlagSchema = z.enum(['active', 'reject', 'deleted']);
export const OrderStatusSchema = z.enum(['new', 'progress', 'closed', 'reject', 'deleted']);

// Идентификатор оператора. Поддерживает три формата:
//   1. Telegram-username: @Daria_HQ — приоритет, если у юзера привязан tg.
//   2. Email-логин: admin@wave.local — fallback для юзеров без tg.
//   3. Произвольный username: admin — для legacy/служебных аккаунтов.
export const OperatorUsername = z.string().min(1).max(64);

export const AccountCode = z.string().min(1).max(64);

export type MoneyStr = z.infer<typeof MoneyStr>;
export type IsoDate = z.infer<typeof IsoDate>;
export type ProvodkaStatusSchema = z.infer<typeof ProvodkaStatusSchema>;
export type StatusFlagSchema = z.infer<typeof StatusFlagSchema>;
export type OrderStatusSchema = z.infer<typeof OrderStatusSchema>;
